export const MAX_VISIBLE_PROJECTS = 3;
